/**
 * Query keys do domínio sales (apps/sales + packages/sales-core).
 *
 * Padrão herdado do `@pps/sales-core` (já usava `["sales", ...]` namespaced).
 * Esta factory consolida o shape e expõe builders tipados para evitar typos
 * de invalidation (ex: `["sales", "lead"]` vs `["sales", "leads"]`).
 */
import { tuple } from "./core";
import type { QueryFilters } from "./types";

const root = ["sales"] as const;

const leads = {
  /** Invalida TODAS as queries de leads (lista, detalhes, filtros). */
  all: tuple(root, "leads"),
  /** Lista paginada/filtrada de leads de uma organização. */
  list: <F extends QueryFilters>(orgId: string | null | undefined, filters?: F) =>
    tuple(root, "leads", "list", orgId, filters),
  /** Detalhe de um lead. */
  byId: (leadId: string | null | undefined) => tuple(root, "leads", "detail", leadId),
} as const;

const deals = {
  all: tuple(root, "deals"),
  list: <F extends QueryFilters>(orgId: string | null | undefined, filters?: F) =>
    tuple(root, "deals", "list", orgId, filters),
  byId: (dealId: string | null | undefined) => tuple(root, "deals", "detail", dealId),
} as const;

const pipelines = {
  all: tuple(root, "pipelines"),
  byOrg: (orgId: string | null | undefined) => tuple(root, "pipelines", "by-org", orgId),
} as const;

const opportunities = {
  /** Invalida todas as queries de oportunidades (CRM legacy). */
  all: tuple(root, "opportunities"),
  /** Lista de oportunidades de um clube. */
  byClub: (clubId: string | null | undefined) =>
    tuple(root, "opportunities", "by-club", clubId),
  /** Oportunidades vinculadas a um lead. */
  byLead: (leadId: string | null | undefined) =>
    tuple(root, "opportunities", "by-lead", leadId),
} as const;

export const sales = {
  all: root,
  leads,
  deals,
  pipelines,
  opportunities,
} as const;
